import { useEffect } from "react";
import { observer } from "mobx-react";
import { LoadingIndicator } from "@/components-v2/LoadingIndicator";
import { useDispatch, useRootStore } from "@/stores/RootStoreContext";
import { resolveCompanyId } from "./companyByIdDomain";

export const CompanyByIdPage = observer(({ companyId }: { companyId: string }) => {
  const dispatch = useDispatch();
  const { pathname, search } = useRootStore().location;

  useEffect(() => {
    dispatch(resolveCompanyId(companyId, { pathname, search }));
  }, [dispatch, companyId, pathname, search]);

  return <LoadingIndicator fullscreen />;
});
